import React, { Suspense } from "react"
import { Outlet } from "react-router-dom"

const PublicContainer = () => (
  <Suspense>
    <Outlet />
  </Suspense>
)

export default PublicContainer